import React, { useEffect } from 'react';
import { DeviceMobileIcon } from './icons';

export const Confetti = () => {
    return (
        <div className="confetti-container fixed inset-0 z-50 pointer-events-none flex justify-center">
            {Array.from({ length: 100 }).map((_, i) => (
                /* eslint-disable-next-line react/no-inline-styles, no-inline-styles */
                <div
                    key={i}
                    className="confetti-piece"
                    style={{
                        '--c-left': `${Math.random() * 100}vw`,
                        '--c-top': `-10px`,
                        '--c-bg': ['#EF4444', '#3B82F6', '#10B981', '#F59E0B', '#8B5CF6'][Math.floor(Math.random() * 5)],
                        '--c-dur': `${1 + Math.random() * 2}s`,
                        '--c-delay': `${Math.random() * 0.5}s`,
                    } as React.CSSProperties}
                />
            ))}
        </div>
    );
};

export const CelebrationOverlay = ({ onClose }: { onClose: () => void }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 4000);
        return () => clearTimeout(timer);
    }, [onClose]);

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 backdrop-blur-sm transition-opacity duration-700 animate-fade-out-delayed">
            <Confetti />
            <div className="bg-white p-10 rounded-3xl shadow-2xl text-center transform scale-100 animate-bounce-in max-w-lg mx-4 border-4 border-blue-100">
                <div className="w-28 h-28 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-inner">
                    <span className="text-6xl">🎉</span>
                </div>
                <h2 className="text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600 mb-4">
                    Tebrikler!
                </h2>
                <p className="text-xl text-gray-700 font-medium leading-relaxed">
                    Hedefin için 1 adım daha attın, ilerlemeye devam et! 🚀
                </p>
            </div>
        </div>
    );
};

export const SadOverlay = ({ onClose }: { onClose: () => void }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 3000);
        return () => clearTimeout(timer);
    }, [onClose]);

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 backdrop-blur-sm transition-opacity duration-700 animate-fade-out-delayed">
            <div className="bg-white p-10 rounded-3xl shadow-2xl text-center transform scale-100 animate-bounce-in max-w-lg mx-4 border-4 border-gray-100">
                <div className="w-28 h-28 bg-gray-100 text-gray-500 rounded-full flex items-center justify-center mx-auto mb-6 shadow-inner">
                    <span className="text-6xl">😔</span>
                </div>
                <h2 className="text-2xl font-bold text-gray-700 mb-2">
                    Bugünlük Olmadı
                </h2>
                <p className="text-gray-500">
                    Sorun değil, yarın daha güçlü geri dönebilirsin.
                </p>
            </div>
        </div>
    );
};

// SMS Simulation Component
export const SMSNotification = ({ message, onClose }: { message: string, onClose: () => void }) => {
    useEffect(() => {
        const timer = setTimeout(onClose, 5000);
        return () => clearTimeout(timer);
    }, [onClose]);

    return (
        <div className="fixed top-4 right-4 z-[150] bg-gray-800 text-white rounded-2xl shadow-2xl p-4 max-w-sm animate-slide-in-right border border-gray-700">
            <div className="flex items-center gap-3 mb-2 border-b border-gray-700 pb-2">
                <div className="p-1.5 bg-green-500 rounded-lg">
                    <DeviceMobileIcon className="w-4 h-4 text-white" />
                </div>
                <span className="font-bold text-sm">Yeni Mesaj • SUPERVISOR</span>
            </div>
            <p className="text-sm leading-relaxed text-gray-200">{message}</p>
        </div>
    );
};
